import React, { Component } from 'react';

export default class EmptyState extends Component {
  render() {
    return <div className="well">
        { this.props.message }
      </div>;
  }
}